/*
 * Tackle Express - Labor Day sale variant emphasis.
 * Highlights sale-priced variant names and prioritizes sale variants in selectors.
 */
(function () {
  'use strict';

  if (window.__teLaborSaleVariants) return;
  window.__teLaborSaleVariants = true;

  var STYLE_ID = 'te-labor-sale-variant-style';
  var SALE_CLASS = 'te-labor-sale-variant-name';
  var SELECTED_CLASS = 'te-labor-sale-selected';
  var NATIVE_SELECT_CLASS = 'te-labor-native-select';
  var CUSTOM_SELECT_CLASS = 'te-labor-custom-select';
  var userSelectionMade = false;

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.' + SALE_CLASS + ',',
      'option.' + SALE_CLASS + ' {',
      '  color: #d30e1a !important;',
      '  font-weight: 700 !important;',
      '}',
      'select.' + SELECTED_CLASS + ' {',
      '  color: #d30e1a !important;',
      '  font-weight: 700 !important;',
      '}',
      'select.' + NATIVE_SELECT_CLASS + ' {',
      '  position: absolute !important;',
      '  width: 1px !important;',
      '  height: 1px !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + ' {',
      '  position: relative;',
      '  width: 100%;',
      '  margin-top: 0.5rem;',
      '  margin-bottom: 0.5rem;',
      '  z-index: 20;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__button {',
      '  width: 100%;',
      '  min-height: 44px;',
      '  display: block;',
      '  padding: 0.625rem 2rem 0.625rem 1.25rem;',
      '  border: 1px solid currentColor;',
      '  background: rgba(var(--background-color), 1);',
      '  color: inherit;',
      '  text-align: left;',
      '  cursor: pointer;',
      '  -webkit-appearance: none;',
      '  appearance: none;',
      '  touch-action: manipulation;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__button::after {',
      '  content: "";',
      '  position: absolute;',
      '  right: 1rem;',
      '  top: 50%;',
      '  width: 0.5rem;',
      '  height: 0.5rem;',
      '  border-right: 1px solid currentColor;',
      '  border-bottom: 1px solid currentColor;',
      '  transform: translateY(-65%) rotate(45deg);',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__list {',
      '  position: absolute;',
      '  top: calc(100% + 4px);',
      '  left: 0;',
      '  right: 0;',
      '  max-height: min(360px, 60vh);',
      '  overflow-y: auto;',
      '  -webkit-overflow-scrolling: touch;',
      '  background: #ffffff;',
      '  border: 1px solid rgba(1, 34, 51, 0.18);',
      '  box-shadow: 0 12px 32px rgba(1, 34, 51, 0.18);',
      '  border-radius: 8px;',
      '  padding: 0.35rem 0;',
      '  z-index: 999;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__list[hidden] {',
      '  display: none !important;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__option {',
      '  display: block;',
      '  width: 100%;',
      '  padding: 0.5rem 0.9rem;',
      '  border: 0;',
      '  background: transparent;',
      '  color: #012233;',
      '  text-align: left;',
      '  cursor: pointer;',
      '  -webkit-user-select: none;',
      '  user-select: none;',
      '  touch-action: manipulation;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__option:hover,',
      '.' + CUSTOM_SELECT_CLASS + '__option[aria-selected="true"] {',
      '  background: rgba(1, 34, 51, 0.06);',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__option.' + SALE_CLASS + ' {',
      '  color: #d30e1a !important;',
      '  font-weight: 700 !important;',
      '}',
      '.' + CUSTOM_SELECT_CLASS + '__option[data-available="false"] {',
      '  opacity: 0.78;',
      '}',
      '@media (max-width: 749px) {',
      '  .' + CUSTOM_SELECT_CLASS + ' {',
      '    display: block !important;',
      '    z-index: 1000;',
      '  }',
      '  .' + CUSTOM_SELECT_CLASS + '__list {',
      '    width: min(360px, calc(100vw - 40px));',
      '    min-width: min(320px, calc(100vw - 40px));',
      '    max-height: min(420px, 52vh);',
      '    z-index: 10000;',
      '  }',
      '  .' + CUSTOM_SELECT_CLASS + '__option {',
      '    min-height: 44px;',
      '    padding-top: 0.68rem;',
      '    padding-bottom: 0.68rem;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function parseVariant(script) {
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function isSaleVariant(variant) {
    if (!variant) return false;

    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    return compareAt > price;
  }

  function getSalePercent(variant) {
    if (!isSaleVariant(variant)) return '';

    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    return String(Math.round(((compareAt - price) / compareAt) * 100));
  }

  function triggerElementClick(element) {
    if (!element) return;

    if (typeof element.click === 'function') {
      element.click();
      return;
    }

    var event;
    if (typeof MouseEvent === 'function') {
      event = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
    } else {
      event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, true, window, 1);
    }

    element.dispatchEvent(event);
  }

  function getVariantMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }
    if (variant.featured_image && variant.featured_image.id) {
      return String(variant.featured_image.id);
    }
    return '';
  }

  function getVariantById(variantId) {
    if (!variantId) return null;

    var scripts = document.querySelectorAll('script[data-option-value-id][data-resource]');
    for (var i = 0; i < scripts.length; i++) {
      var variant = parseVariant(scripts[i]);
      if (variant && String(variant.id) === String(variantId)) {
        return variant;
      }
    }

    return null;
  }

  function getCurrentVariantIdFromPage() {
    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (variantId) return variantId;

    var selectedOption = document.querySelector('select option[data-te-labor-variant-id]:checked');
    return selectedOption ? selectedOption.getAttribute('data-te-labor-variant-id') : '';
  }

  function mediaIdMatches(value, mediaId) {
    if (!value || !mediaId) return false;
    value = String(value);
    mediaId = String(mediaId);
    return value === mediaId || value.slice(-mediaId.length) === mediaId;
  }

  function activateVariantMedia(variantId) {
    var variant = getVariantById(variantId);
    var mediaId = getVariantMediaId(variant);
    if (!mediaId) return false;

    var mediaNodes = Array.prototype.slice.call(document.querySelectorAll('[data-media-id]')).filter(function (node) {
      return mediaIdMatches(node.getAttribute('data-media-id'), mediaId);
    });
    if (!mediaNodes.length) return false;

    var thumbnails = mediaNodes.filter(function (node) {
      return /(^|\s)(x-thumbnail|media-thumbnail)(\s|$)/.test(node.className || '');
    });
    var slides = mediaNodes.filter(function (node) {
      return /(^|\s)(media-slide|splide__slide)(\s|$)/.test(node.className || '');
    });
    var target = thumbnails[0] || slides[0] || mediaNodes[0];

    triggerElementClick(target.querySelector('button, a') || target);
    target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
    return true;
  }

  function scheduleVariantMediaSync(variantId) {
    if (!variantId) return;

    [80, 350, 900, 1600].forEach(function (delay) {
      window.setTimeout(function () {
        activateVariantMedia(variantId);
      }, delay);
    });
  }

  function updateSaleOptionLabel(option, onSale) {
    if (!option.hasAttribute('data-te-labor-base-label')) {
      option.setAttribute(
        'data-te-labor-base-label',
        option.textContent.trim()
          .replace(/\s+SALE(?:\s+-\s+Save\s+\d+%)?$/, '')
          .replace(/\s+-\s+Sale\s+\d+%$/, '')
      );
    }

    var baseLabel = option.getAttribute('data-te-labor-base-label') || '';
    var salePercent = option.getAttribute('data-te-labor-sale-percent');
    var saleLabel = baseLabel;
    if (onSale && salePercent) {
      saleLabel += ' - SAVE ' + salePercent + '%';
    }
    option.textContent = onSale ? saleLabel : baseLabel;
  }

  function applySalePresentation(element, onSale) {
    element.setAttribute('data-te-labor-sale', onSale ? 'true' : 'false');
    element.classList.toggle(SALE_CLASS, onSale);

    if (element.tagName === 'OPTION') {
      updateSaleOptionLabel(element, onSale);
      if (onSale) {
        element.style.setProperty('color', '#d30e1a', 'important');
        element.style.setProperty('font-weight', '700', 'important');
      } else {
        element.style.removeProperty('color');
        element.style.removeProperty('font-weight');
      }
    }
  }

  function dispatchNativeEvent(element, type) {
    var event;

    if (typeof Event === 'function') {
      event = new Event(type, { bubbles: true });
    } else {
      event = document.createEvent('HTMLEvents');
      event.initEvent(type, true, false);
    }

    element.dispatchEvent(event);
  }

  function markOption(script) {
    var variant = parseVariant(script);
    var optionValueId = script.getAttribute('data-option-value-id');
    var resource = (script.getAttribute('data-resource') || '').trim();
    var onSale = isSaleVariant(variant);
    var salePercent = getSalePercent(variant);
    var selector = '[data-option-value-id="' + cssEscape(optionValueId) + '"]';
    var controls = document.querySelectorAll(selector);

    for (var i = 0; i < controls.length; i++) {
      if (salePercent) {
        controls[i].setAttribute('data-te-labor-sale-percent', salePercent);
      } else {
        controls[i].removeAttribute('data-te-labor-sale-percent');
      }
      applySalePresentation(controls[i], onSale);
      if (variant && variant.id) {
        controls[i].setAttribute('data-te-labor-variant-id', String(variant.id));
      }
    }

    if (!resource) return;

    var label = document.querySelector('label[for="' + cssEscape(resource) + '"]');
    if (label) {
      applySalePresentation(label, onSale);
    }
  }

  function sortSelect(select) {
    var options = Array.prototype.slice.call(select.options);
    var movable = options.filter(function (option) {
      return option.hasAttribute('data-option-value-id');
    });

    if (!movable.length) return;
  }

  function syncSelectStyle(select) {
    var option = select.options[select.selectedIndex];
    var onSale = option && option.getAttribute('data-te-labor-sale') === 'true';
    select.classList.toggle(SELECTED_CLASS, !!onSale);
  }

  function closeAllCustomSelects(except) {
    var wrappers = document.querySelectorAll('.' + CUSTOM_SELECT_CLASS);
    for (var i = 0; i < wrappers.length; i++) {
      if (except && wrappers[i] === except) continue;
      wrappers[i].classList.remove('is-open');
      var list = wrappers[i].querySelector('.' + CUSTOM_SELECT_CLASS + '__list');
      var button = wrappers[i].querySelector('.' + CUSTOM_SELECT_CLASS + '__button');
      if (list) list.hidden = true;
      if (button) button.setAttribute('aria-expanded', 'false');
    }
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function navigateToVariant(option) {
    var variantId = option && option.getAttribute('data-te-labor-variant-id');
    if (!variantId) return false;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.location.href = url.toString();
    return true;
  }

  function selectOption(select, option, index) {
    if (!select || !option) return;

    userSelectionMade = true;
    window.__teLaborSaleUserSelectionMade = true;

    if (isMobileViewport() && navigateToVariant(option)) return;

    select.selectedIndex = index;
    select.value = option.value;
    Array.prototype.forEach.call(select.options, function (selectOptionItem) {
      selectOptionItem.removeAttribute('selected');
      selectOptionItem.selected = false;
    });
    option.setAttribute('selected', 'selected');
    option.selected = true;
    syncSelectStyle(select);
    updateCustomSelect(select);
    closeAllCustomSelects();
    dispatchNativeEvent(select, 'input');
    dispatchNativeEvent(select, 'change');
    scheduleVariantMediaSync(option.getAttribute('data-te-labor-variant-id'));
  }

  function closestOptionButton(element, list) {
    while (element && element !== list) {
      if (element.classList && element.classList.contains(CUSTOM_SELECT_CLASS + '__option')) {
        return element;
      }
      element = element.parentNode;
    }

    return null;
  }

  function updateCustomSelect(select) {
    var wrapper = select.__teLaborSaleCustomSelect;
    if (!wrapper) return;

    var button = wrapper.querySelector('.' + CUSTOM_SELECT_CLASS + '__button');
    var list = wrapper.querySelector('.' + CUSTOM_SELECT_CLASS + '__list');
    var selectedOption = select.options[select.selectedIndex];
    var selectedOnSale = selectedOption && selectedOption.getAttribute('data-te-labor-sale') === 'true';

    button.textContent = selectedOption ? selectedOption.textContent.trim() : '';
    button.classList.toggle(SALE_CLASS, !!selectedOnSale);
    button.style.color = selectedOnSale ? '#d30e1a' : '';
    button.style.fontWeight = selectedOnSale ? '700' : '';
    list.innerHTML = '';

    var options = Array.prototype.slice.call(select.options).map(function (option, index) {
      return { option: option, index: index };
    }).filter(function (entry) {
      return entry.option.hasAttribute('data-option-value-id');
    });

    options.sort(function (a, b) {
      var aSale = a.option.getAttribute('data-te-labor-sale') === 'true';
      var bSale = b.option.getAttribute('data-te-labor-sale') === 'true';
      var aAvailable = a.option.getAttribute('data-available') === 'true';
      var bAvailable = b.option.getAttribute('data-available') === 'true';
      var aRank = aSale && aAvailable ? 0 : aAvailable ? 1 : aSale ? 2 : 3;
      var bRank = bSale && bAvailable ? 0 : bAvailable ? 1 : bSale ? 2 : 3;

      if (aRank !== bRank) return aRank - bRank;
      return a.index - b.index;
    });

    options.forEach(function (entry) {
      var option = entry.option;
      var index = entry.index;
      if (!option.hasAttribute('data-option-value-id')) return;

      var item = document.createElement('button');
      var onSale = option.getAttribute('data-te-labor-sale') === 'true';
      item.type = 'button';
      item.className = CUSTOM_SELECT_CLASS + '__option';
      item.textContent = option.textContent.trim();
      item.setAttribute('role', 'option');
      item.setAttribute('data-index', String(index));
      item.setAttribute('data-available', option.getAttribute('data-available') || '');
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      if (option.getAttribute('data-te-labor-variant-id')) {
        item.setAttribute('data-te-labor-variant-id', option.getAttribute('data-te-labor-variant-id'));
      }

      if (onSale) {
        item.classList.add(SALE_CLASS);
        item.style.setProperty('color', '#d30e1a', 'important');
        item.style.setProperty('font-weight', '700', 'important');
      }

      list.appendChild(item);
    });
  }

  function ensureCustomSelect(select) {
    if (select.__teLaborSaleCustomSelect) {
      updateCustomSelect(select);
      return;
    }

    if (!select.querySelector('option[data-option-value-id]')) return;
    if (select.closest('.cbb-frequently-bought-container, .jdgm-widget')) return;

    select.classList.add(NATIVE_SELECT_CLASS);

    var wrapper = document.createElement('div');
    var button = document.createElement('button');
    var list = document.createElement('div');
    var listId = 'te-labor-sale-list-' + Math.random().toString(36).slice(2);

    wrapper.className = CUSTOM_SELECT_CLASS;
    button.type = 'button';
    button.className = CUSTOM_SELECT_CLASS + '__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', listId);

    list.id = listId;
    list.className = CUSTOM_SELECT_CLASS + '__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    list.__teLaborTouchStart = null;
    list.__teLaborLastTouchEnd = 0;

    var chooseFromList = function (event) {
      var item = closestOptionButton(event.target, list);
      if (!item) return;

      if (event.type === 'touchend') {
        var changedTouch = event.changedTouches && event.changedTouches[0];
        var start = list.__teLaborTouchStart;

        list.__teLaborLastTouchEnd = Date.now();
        if (start && changedTouch) {
          var movedX = Math.abs(changedTouch.clientX - start.x);
          var movedY = Math.abs(changedTouch.clientY - start.y);
          if (movedX > 10 || movedY > 10) return;
        }
      } else if (event.type === 'click' && Date.now() - list.__teLaborLastTouchEnd < 500) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var index = Number(item.getAttribute('data-index'));
      var option = select.options[index];
      selectOption(select, option, index);
    };

    list.addEventListener('touchstart', function (event) {
      var touch = event.touches && event.touches[0];
      list.__teLaborTouchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });
    list.addEventListener('touchend', chooseFromList, { passive: false });
    list.addEventListener('pointerup', function (event) {
      if (event.pointerType === 'touch') {
        list.__teLaborLastTouchEnd = Date.now();
        chooseFromList(event);
      }
    });
    list.addEventListener('click', chooseFromList);

    var lastButtonTouchTime = 0;
    var toggleList = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (event && event.type === 'touchend') {
        lastButtonTouchTime = Date.now();
      } else if (event && event.type === 'click' && Date.now() - lastButtonTouchTime < 500) {
        return;
      }

      var willOpen = list.hidden;
      closeAllCustomSelects(wrapper);
      list.hidden = !willOpen;
      wrapper.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    };

    button.addEventListener('touchend', toggleList);
    button.addEventListener('click', toggleList);

    button.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllCustomSelects();
        button.focus();
      }
    });

    wrapper.appendChild(button);
    wrapper.appendChild(list);
    select.insertAdjacentElement('afterend', wrapper);
    select.__teLaborSaleCustomSelect = wrapper;

    select.addEventListener('change', function () {
      updateCustomSelect(select);
    });

    updateCustomSelect(select);
  }

  function maybeSelectFirstSaleVariant(select) {
    if (userSelectionMade || window.__teLaborSaleUserSelectionMade) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (select.__teLaborSaleAutoSelected) return;

    var productScope = select.closest('[id^="variant-update-"], .x-variant-picker, form[action*="/cart/add"]') || document;
    var productSelects = productScope.querySelectorAll('select');

    if (productSelects.length !== 1) return;

    var firstSaleAvailable = Array.prototype.find.call(select.options, function (option) {
      return option.getAttribute('data-te-labor-sale') === 'true'
        && option.getAttribute('data-available') === 'true';
    });

    if (!firstSaleAvailable || firstSaleAvailable.selected) return;

    select.__teLaborSaleAutoSelected = true;
    select.value = firstSaleAvailable.value;
    firstSaleAvailable.selected = true;
    syncSelectStyle(select);
    dispatchNativeEvent(select, 'input');
    dispatchNativeEvent(select, 'change');
  }

  function refresh(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var scripts = scope.querySelectorAll('script[data-option-value-id][data-resource]');

    for (var i = 0; i < scripts.length; i++) {
      markOption(scripts[i]);
    }

    var selects = document.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      sortSelect(selects[j]);
      syncSelectStyle(selects[j]);
      ensureCustomSelect(selects[j]);
      maybeSelectFirstSaleVariant(selects[j]);
      if (!selects[j].__teLaborSaleListening) {
        selects[j].__teLaborSaleListening = true;
        selects[j].addEventListener('change', function (event) {
          userSelectionMade = true;
          window.__teLaborSaleUserSelectionMade = true;
          syncSelectStyle(event.currentTarget);
          updateCustomSelect(event.currentTarget);
        });
      }
    }
  }

  function scheduleRefreshes() {
    [0, 250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        refresh(document);
      }, delay);
    });
  }

  function boot() {
    addStyles();
    refresh(document);
    scheduleRefreshes();
    scheduleVariantMediaSync(getCurrentVariantIdFromPage());

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.closest && node.closest('.' + CUSTOM_SELECT_CLASS)) continue;
          if (node.classList && node.classList.contains(CUSTOM_SELECT_CLASS)) continue;
          if (node.matches && node.matches('script[data-option-value-id][data-resource], select')) {
            refresh(document);
            continue;
          }
          if (node.querySelector && node.querySelector('script[data-option-value-id][data-resource], select')) {
            refresh(document);
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest || event.target.closest('.' + CUSTOM_SELECT_CLASS)) return;
    closeAllCustomSelects();
  });

  window.addEventListener('popstate', function () {
    scheduleVariantMediaSync(getCurrentVariantIdFromPage());
  });
})();
